export default "__VITE_PUBLIC_ASSET__b3f02364__"